import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";

//redux store
import { Provider } from "react-redux";
import { store } from "./redux/store";
//import 'antd/dist/antd.css';
import "antd/dist/reset.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-bootstrap-typeahead/css/Typeahead.css";
import "./assets/scss/main.scss";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { HMSRoomProvider } from "@100mslive/react-sdk";
import {
  BrowserCacheLocation,
  PublicClientApplication,
} from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { ErrorBoundary } from "react-error-boundary";
import ErrorFallbackComponent from "./_uiComponents/ErrorFallbackComponent";
import { AuthProvider } from "./_hooks/useAuthContext";

const configuration = {
  auth: {
    clientId: process.env.REACT_APP_MICROSOFT_CLIENT_ID,
    authority: "https://login.microsoftonline.com/common",
    // redirectUri: "http://localhost:3000",
    navigateToLoginRequestUrl: true,
  },
  cache: {
    cacheLocation: BrowserCacheLocation.SessionStorage,
  },
};
const pca = new PublicClientApplication(configuration);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  <ErrorBoundary FallbackComponent={ErrorFallbackComponent}>
    <MsalProvider instance={pca}>
      <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
        <Provider store={store}>
          <HMSRoomProvider>
            <AuthProvider>
              <App />
            </AuthProvider>
          </HMSRoomProvider>
        </Provider>
      </GoogleOAuthProvider>
    </MsalProvider>
  </ErrorBoundary>
  // </React.StrictMode>
);
